export default __webpack_public_path__ + "static/media/milestone 2200.0f4a5241.svg";